//Ajax Cart Count Function Start
document.addEventListener('DOMContentLoaded', function () {

document.addEventListener('click', function (e) {
  const option = e.target.closest('.pl--gift_variant_option');
  if (!option) return;

  // Get image src
  const img = option.querySelector('img');
  const imageSrc = img ? img.getAttribute('src') : '';
  console.log(imageSrc);

  // Set hidden input value
  const giftInput = document.getElementById('pl--giftimage');
  if (giftInput) {
      giftInput.value = imageSrc;
  }

  // Toggle active class
  option.parentElement
      .querySelectorAll('.pl--gift_variant_option')
      .forEach(el => el.classList.remove('active'));
  option.classList.add('active');

  // Go to slide (Swiper)
  const slideIndex = option.getAttribute('data-slide-index');
  if (window.productSlider && slideIndex !== null) {
      window.productSlider.slideToLoop(Number(slideIndex));
  }
});
const deviceWidth = window.innerWidth;

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.pl--video_popup_btn, .video-cover, .brand-video');
    if (!trigger) return;
    e.preventDefault();

    // Get video HTML
    const videoDataEl = document.querySelector('.pl--video_data');
    const videoData = videoDataEl ? videoDataEl.innerHTML : '';

    // Insert video
    const popupVideo = document.querySelector('.pop-up-video-section .popup-video');
    if (popupVideo) {
      popupVideo.innerHTML = videoData;
    }

    // Show popup (fadeIn equivalent)
    document.querySelectorAll('.popup-overlay, .pop-up-video-section').forEach(el => {
      el.style.display = 'block';
      el.style.opacity = '0';
      setTimeout(() => {
        el.style.transition = 'opacity 0.4s ease';
        el.style.opacity = '1';
      }, 10);
    });

    // Add active class
    const popupSection = document.querySelector('.pop-up-video-section');
    if (popupSection) {
      popupSection.classList.add('show');
    }

    // Prevent background scroll
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');

    // Select correct video based on device width
    let videoEl;
    if (deviceWidth > 732) {
      videoEl = document.querySelector(
        '.pop-up-video-section.show .popup-video .small-hide video, #pl--grid__custom_video_2'
      );
    } else {
      videoEl = document.querySelector(
        '.pop-up-video-section.show .popup-video .medium-hide video, #pl--grid__custom_video_2'
      );
    }
    // Unmute video
    if (videoEl) {
      videoEl.muted = false;
    }
  });


  // Close popup (overlay or close button)
  document.addEventListener('click', function (e) {
    if (e.target.closest('.popup-close') || e.target.closest('.popup-overlay')) {
      document.body.classList.remove('overflow-hidden');
      document.documentElement.classList.remove('overflow-hidden');
      const popupVideo = document.querySelector('.pop-up-video-section .popup-video');
      if (popupVideo) {
        popupVideo.innerHTML = '';
      }
      document.querySelectorAll('.popup-overlay, .pop-up-video-section').forEach(el => {
        el.style.display = 'none';
      });
    }
  });

  // Open popup
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.pl--video_popup_btn');
    if (!btn) return;
    e.preventDefault();
    const videoDataEl = btn.nextElementSibling;
    if (!videoDataEl || !videoDataEl.classList.contains('pl--video_data')) return;
    const popupVideo = document.querySelector('.pop-up-video-section .popup-video');
    if (popupVideo) {
      popupVideo.innerHTML = videoDataEl.innerHTML;
    }
    document.querySelectorAll('.popup-overlay, .pop-up-video-section').forEach(el => {
      el.style.display = 'block';
    });
    document.body.classList.add('overflow-hidden');
    document.documentElement.classList.add('overflow-hidden');
  });
  function cartCount() {
      fetch('/cart.js', {
      method: 'GET',
      headers: {
          'Accept': 'application/json'
      }
      })
      .then(function (response) {
          return response.json();
      })
      .then(function (cart) {
          // Update cart count text
          document.querySelectorAll('.cart-count-bubble > span').forEach(function (span) {
          span.innerHTML = cart.item_count;
          });
  
          const cartDrawer = document.querySelector('cart-drawer.pl-cart-drawer');
          const body = document.body;
  
          if (cart.item_count >= 1) {
          if (cartDrawer) {
              cartDrawer.classList.remove('is-empty');
              cartDrawer.classList.add('active');
          }
  
          body.classList.add('overflow-hidden');
  
          const cartIconBubble = document.querySelector('#cart-icon-bubble');
          if (cartIconBubble) {
              cartIconBubble.insertAdjacentHTML(
              'beforeend',
              `<div class="cart-count-bubble">
                  <span aria-hidden="true">${cart.item_count}</span>
                  <span class="visually-hidden">${cart.item_count} items</span>
              </div>`
              );
          }
          } else {
          if (cartDrawer) {
              cartDrawer.classList.add('is-empty');
          }
          }
      })
      .catch(function (error) {
          console.error('Failed to update cart count:', error);
      });
  }
  function updateMiniCart(currentThis) {
      fetch('/', {
          method: 'GET',
          headers: {
          'Accept': 'text/html'
          }
      })
      .then(function (response) {
      return response.text();
      })
      .then(function (html) {
      // Parse returned HTML
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, 'text/html');

      const newDrawerInner = doc.querySelector('#CartDrawer .drawer__inner');

      const currentDrawerInner = document.querySelector('#CartDrawer .drawer__inner');

      if (newDrawerInner && currentDrawerInner) {
          currentDrawerInner.innerHTML = newDrawerInner.innerHTML;
      }
      })
      .catch(function (error) {
      console.error('Mini cart update failed:', error);
      });
  }
  function ajaxAddToCartProduct(currentThis, dynamicData) {
      fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
      },
      body: JSON.stringify({
          items: dynamicData
      })
      })
      .then(function (response) {
          if (!response.ok) {
          return response.json().then(function (errorData) {
              throw { status: response.status, data: errorData };
          });
          }
          return response.json();
      })
      .then(function (data) {
          // Success
          document.querySelectorAll('.loading-overlay__spinner').forEach(function (el) {
          el.classList.add('hidden');
          });
  
          document.querySelectorAll('.button-shop--now, .confirm_basket, .fbt_btn_add').forEach(function (el) {
              el.classList.remove('is-loading');
          });
  
          const activeGrid = document.querySelector('.grid__item.active-grid');
          if (activeGrid) {
          const quickViewBtn = activeGrid.querySelector('.pl--quickView');
          const quickViewWrapper = activeGrid.querySelector('.quick-view-wrapper');
  
          if (quickViewBtn) {
              quickViewBtn.setAttribute('data-btn', 'quickview');
          }
  
          if (quickViewWrapper) {
              quickViewWrapper.style.display = 'none';
          }
          }
          cartCount();
          updateMiniCart(currentThis);
          
      })
      .catch(function (err) {
          // Error
          document.querySelectorAll('.loading-overlay__spinner').forEach(function (el) {
          el.classList.add('hidden');
          });
  
          document.querySelectorAll('.button-shop--now, .confirm_basket, .fbt_btn_add')
          .forEach(function (el) {
              el.classList.remove('is-loading');
          });
  
          if (err.status === 400 && err.data?.message) {
          alert(err.data.message);
          }
  
          if (err.status === 422 && err.data?.description) {
          alert(err.data.description);
          }
      });
  }
  function ajaxAddToCartProductNew(currentThis, dynamicData) {
      fetch('/cart/add.js', {
      method: 'POST',
      headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
      },
      body: JSON.stringify({
          items: dynamicData
      })
      })
      .then(function (response) {
          if (!response.ok) {
          return response.json().then(function (errorData) {
              throw { status: response.status, data: errorData };
          });
          }
          return response.json();
      })
      .then(function (data) {
          // Redirect to checkout on success
          window.location.replace('/checkout');
      })
      .catch(function (err) {
          // Hide spinner
          document.querySelectorAll('.loading-overlay__spinner').forEach(function (el) {
          el.classList.add('hidden');
          });
  
          // Remove loading state from current button
          if (currentThis) {
          currentThis.classList.remove('is-loading');
          }
  
          if (err.status === 400 && err.data?.message) {
          alert(err.data.message);
          }
  
          if (err.status === 422 && err.data?.description) {
          alert(err.data.description);
          }
      });
  }
  // Open custom Quick wrapper
  document.addEventListener('click', function (e) {
      const button = e.target.closest('.button-shop--now[data-btn="quickview"]');
      if (!button) return;
    
      // Reset any previously active card
      document.querySelectorAll('.grid__item.active-grid').forEach(function (item) {
        const quickViewBtn = item.querySelector('.pl--quickView');
        const quickViewWrapper = item.querySelector('.quick-view-wrapper');
    
        if (quickViewBtn) {
          quickViewBtn.setAttribute('data-btn', 'quickview');
        }
    
        if (quickViewWrapper) {
          quickViewWrapper.style.display = 'none';
        }
    
        item.classList.remove('active-grid');
      });
    
      // Activate the clicked card
      const card = button.closest('.grid__item');
      if (!card) return;
    
      card.classList.add('active-grid');
    
      const plQuickView = card.querySelector('.pl--quickView');
      if (plQuickView) {
        plQuickView.setAttribute('data-btn', 'quickview');
      }
    
      const quickViewWrapper = card.querySelector('.quick-view-wrapper');
      if (quickViewWrapper) {
        quickViewWrapper.style.display = 'block';
      }
    
      const thisParentId = button.getAttribute('data-id');
      const thisVarID = button.getAttribute('data-variant');
    
      // console.log('thisVarID::' + thisVarID);
    
      if (thisVarID) {
        const select = document.querySelector('.quick-view-wrapper[data-id="' +thisParentId +'"] select.product_card-form__master-select');
    
        if (select) {
          select.value = thisVarID;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      } else {
        const select = card.querySelector('.quick-view-wrapper[data-id="' + thisParentId + '"] select.product_card-form__master-select');
    
        if (select) {
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
  });
  //  Add variant when only singal 
  document.addEventListener('click', function (e) {
  const button = e.target.closest('.button-shop--now[data-btn="addToCart"]');
  if (!button) return;
  
  const currentThis = button;
  const updateItems = [];
  
  const variantId = currentThis.getAttribute('data-variant');
  const quantity = 1;
  const selling_plan = currentThis.getAttribute('data-sellingplan');
  const orderType = currentThis.getAttribute('data-type');
  
  if (!selling_plan || selling_plan === 'undefined') {
      if (orderType === 'Preorder') {
      updateItems.push({
          id: variantId,
          quantity: quantity,
          properties: { Preorder: 'true' }
      });
      } else {
      updateItems.push({
          id: variantId,
          quantity: quantity
      });
      }
  } else {
      if (orderType === 'Preorder') {
      updateItems.push({
          id: variantId,
          quantity: quantity,
          selling_plan: selling_plan,
          properties: { Preorder: 'true' }
      });
      } else {
      updateItems.push({
          id: variantId,
          quantity: quantity,
          selling_plan: selling_plan
      });
      }
  }
  
  // Call existing function
  ajaxAddToCartProduct(currentThis, updateItems);
  
  // Add loading state
  currentThis.classList.add('is-loading');
  
  const spinner = currentThis.querySelector('.loading-overlay__spinner');
  if (spinner) {
      spinner.classList.remove('hidden');
  }
  });
    // Change variant option
    document.addEventListener('click', function (e) {
        const option = e.target.closest('.quick-view-wrapper .swatches-block .swatches-item-box .swatches-option');
        if (!option) return;
      
        const optionName = option.getAttribute('data-value');
      
        // Remove "selected" class from siblings
        const itemBox = option.closest('.swatches-item-box');
        if (itemBox) {
          itemBox.querySelectorAll('.swatches-option').forEach(function (el) {
            el.classList.remove('selected');});
        }
      
        // Add "selected" class to clicked option
        option.classList.add('selected');
      
        // Update select value and trigger change
        const swatchesBlock = option.closest('.swatches-block');
        if (swatchesBlock) {
          const select = swatchesBlock.querySelector('select');
          if (select) {
            select.value = optionName;
            select.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
    });
    // After change variant opton
    document.addEventListener('change', function (e) {
        const selectEl = e.target.closest('.swatches-block select');
        if (!selectEl) return;
      
        let finalValue = '';
      
        const quickViewWrapper = selectEl.closest('.quick-view-wrapper');
        if (!quickViewWrapper) return;
      
        const thisParentId = quickViewWrapper.getAttribute('data-id');
      
        // Build combined option string
        document.querySelectorAll('.quick-view-wrapper[data-id="' + thisParentId + '"] .swatches-block').forEach(function (block) {
            const select = block.querySelector('select');
            if (select && select.value) {
              finalValue += select.value + ' / ';
            }
        });
      
        // Remove last " / "
        const newstr = finalValue.substring(0, finalValue.length - 3);
      
        // Find matching variant option
        const optionSelector = document.querySelector('.quick-view-wrapper[data-id="' + thisParentId + '"] select.product_card-form__master-select option[check-data-sku="' + newstr +'"]');
      
        if (!optionSelector) return;
      
        const optionValue = optionSelector.value;
      
        // Update master select and trigger change
        const masterSelect = document.querySelector('.quick-view-wrapper[data-id="' + thisParentId +'"] select.product_card-form__master-select');
      
        if (masterSelect) {
          masterSelect.value = optionValue;
          masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
    // Change master selector option
    document.addEventListener('change', function (e) {
      const masterSelect = e.target.closest('.quick-view-wrapper select.product_card-form__master-select');
      if (!masterSelect) return;
  
      const thisMainVal = masterSelect.value;
      const quickViewWrapper = masterSelect.closest('.quick-view-wrapper');
      if (!quickViewWrapper) return;
  
      const thisParentId = quickViewWrapper.getAttribute('data-id');
  
      const activeSub = document.querySelector('.quick-view-wrapper[data-id="' + thisParentId + '"] .pl--custom_subscription_options .subscription_pan_item.active');
      const thiSubType = activeSub ? activeSub.getAttribute('data-type') : null;
  
      const sellingPlanSelect = document.querySelector('.quick-view-wrapper[data-id="' + thisParentId + '"] .pl--prod_selling_palns');
      const ThisSellingPlan = sellingPlanSelect ? sellingPlanSelect.value : '';
  
      const selectedOption = masterSelect.querySelector('option[value="' + thisMainVal + '"]');
      if (!selectedOption) return;
  
      const ThisProdAvail = selectedOption.getAttribute('data-varaint-availability');
      const ThisProdNP = selectedOption.getAttribute('data-price');
      const ThisProdSP = selectedOption.getAttribute('data-price-sp');
      const ThisOrderType = selectedOption.getAttribute('data-type');
  
      const quickViewBtn = document.querySelector('.pl--quickView[data-id="' + thisParentId + '"]');
      const priceWrapper = document.querySelector('.quick-view-wrapper[data-id="' + thisParentId + '"] .pl--quick_price');
      const subscriptionBox = document.querySelector('.quick-view-wrapper[data-id="' + thisParentId + '"] .pl--subscription');
      const cardWrapper = quickViewBtn ? quickViewBtn.closest('.product-card-wrapper') : null;
  
      // --- 1. Immediate Visual Feedback (Price/Box visibility) ---
      if (priceWrapper) {
          const priceItem = priceWrapper.querySelector('.price-item');
          const strikePrice = priceWrapper.querySelector('.price__regular');
          const spText = priceWrapper.querySelector('.hawkstonine_price_text');
  
          if (priceItem) priceItem.textContent = ThisProdNP;
          if (spText) spText.textContent = ThisProdSP;
  
          if (thiSubType === 'subscription') {
              if (strikePrice) strikePrice.classList.add('pl-price-strike');
              if (subscriptionBox) subscriptionBox.style.display = 'block';
          } else {
              if (strikePrice) strikePrice.classList.remove('pl-price-strike');
              if (subscriptionBox) subscriptionBox.style.display = 'none';
          }
      }
  
      // --- 2. Delayed Attribute & Button Update ---
      // This prevents scripts from "grabbing" the wrong attributes during rapid changes
      setTimeout(function() {
          if (quickViewBtn) {
              // Set Variant and Selling Plan
              quickViewBtn.setAttribute('data-variant', thisMainVal);
              quickViewBtn.setAttribute('data-sellingplan', thiSubType === 'subscription' ? ThisSellingPlan : '');
  
              const btnText = quickViewBtn.querySelector('.btn_text');
              
              /* ---------- Availability Logic ---------- */
              if (ThisProdAvail === 'true') {
                  quickViewBtn.setAttribute('data-btn', 'addToCart');
                  
                  if (ThisOrderType === 'Preorder') {
                      if (btnText) btnText.textContent = 'Preorder';
                      updateCardUI(cardWrapper, 'Preorder', 'add', 'soldout');
                  } else {
                      if (btnText) btnText.textContent = 'Add To Basket';
                      updateCardUI(cardWrapper, 'confirm selection', 'add', 'soldout');
                  }
              } else {
                  quickViewBtn.setAttribute('data-btn', 'soldout');
                  if (btnText) btnText.textContent = 'Sold Out';
                  updateCardUI(cardWrapper, 'Sold Out', 'soldout', 'add');
              }
          }
      }, 300); // 300ms delay to prevent auto-click/race conditions
  
      // Helper to keep code clean
      function updateCardUI(wrapper, text, addClass, removeClass) {
          if (!wrapper) return;
          const confirmText = wrapper.querySelector('.confirm_text');
          const confirmBtn = wrapper.querySelector('.confirm_basket');
          if (confirmText) confirmText.textContent = text;
          if (confirmBtn) {
              confirmBtn.classList.add(addClass);
              confirmBtn.classList.remove(removeClass);
          }
      }
  });
    // confirm basket
    document.addEventListener('click', function (e) {
        const confirmBtn = e.target.closest('.confirm_basket');
        if (!confirmBtn) return;
        const cardWrapper = confirmBtn.closest('.product-card-wrapper');
        if (!cardWrapper) return;
        const quickViewBtn = cardWrapper.querySelector('.pl--quickView[data-btn="addToCart"]');
        if (quickViewBtn) {
          quickViewBtn.click();
        }
        confirmBtn.classList.add('is-loading');
        const spinner = confirmBtn.querySelector('.loading-overlay__spinner');
        if (spinner) {
          spinner.classList.remove('hidden');
        }
    });
    // Switch subscription mode
    document.addEventListener('click', function (e) {
        const item = e.target.closest('.pl--custom_subscription_options .subscription_pan_item');
        if (!item) return;
      
        const quickViewWrapper = item.closest('.quick-view-wrapper');
        if (!quickViewWrapper) return;
      
        const thisParentId = quickViewWrapper.getAttribute('data-id');
      
        // Remove active class from all subscription items in this wrapper
        document.querySelectorAll('.quick-view-wrapper[data-id="' + thisParentId + '"] .pl--custom_subscription_options .subscription_pan_item')
          .forEach(function (el) {
            el.classList.remove('active');
          });
      
        // Add active class to clicked item
        item.classList.add('active');
      
        // Trigger change on master select
        const masterSelect = document.querySelector('.quick-view-wrapper[data-id="' + thisParentId + '"] select.product_card-form__master-select');
      
        if (masterSelect) {
          masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
    });
    //   Close Quick wrapper
    document.addEventListener('click', function (e) {
        const closeIcon = e.target.closest('.product-swatches .pl--close_icon');
        if (!closeIcon) return;
      
        const gridItem = closeIcon.closest('.grid__item');
        if (!gridItem) return;
      
        const quickViewBtn = gridItem.querySelector('.pl--quickView');
        const quickViewWrapper = gridItem.querySelector('.quick-view-wrapper');
      
        if (quickViewBtn) {
          quickViewBtn.setAttribute('data-btn', 'quickview');
        }
      
        if (quickViewWrapper) {
          quickViewWrapper.style.display = 'none';
        }
    });
    //   Hide Quick Wrapper when click outside wrapper
    document.addEventListener('mouseup', function (e) {
        const activeCard = document.querySelector('.grid__item.active-grid');
        if (!activeCard) return;
      
        // If click is outside the active card
        if (!activeCard.contains(e.target)) {
          const quickViewBtn = activeCard.querySelector('.pl--quickView');
          const quickViewWrapper = activeCard.querySelector('.quick-view-wrapper');
      
          if (quickViewBtn) {
            quickViewBtn.setAttribute('data-btn', 'quickview');
          }
      
          if (quickViewWrapper) {
            quickViewWrapper.style.display = 'none';
          }
      
          activeCard.classList.remove('active-grid');
        }
    });
    //   Header Mega menu Code Desktop
    document.querySelectorAll('.mega_menu.desktopMenu').forEach(function (menu) {
        menu.addEventListener('mouseenter', function () {
          // Show overlay
          const overlay = document.querySelector('html[country="GB"] .pl-overlay');
          if (overlay) {
            overlay.style.display = 'block';
          }
      
          // Open mega menu
          const megaMenu = menu.querySelector('.mega-menu');
          if (megaMenu) {
            megaMenu.setAttribute('open', 'true');
          }
        });
      
        menu.addEventListener('mouseleave', function () {
          // Hide overlay
          const overlay = document.querySelector('html[country="GB"] .pl-overlay');
          if (overlay) {
            overlay.style.display = 'none';
          }
      
          // Remove body overflow class
          document.body.classList.remove('mega-menu-over-flow');
      
          // Close mega menu
          const megaMenu = menu.querySelector('.mega-menu');
          if (megaMenu) {
            megaMenu.removeAttribute('open');
          }
        });
    });
   

    // PDP Variant change price update
    document.addEventListener('click', function (e) {
      const label = e.target.closest(
        'variant-selects .product-form__input label'
      );
      if (!label) return;
    
      // Get value from previous input
      const input = label.previousElementSibling;
      if (!input) return;
    
      const thisValue = input.getAttribute('value');
      console.log('thisValue::' + thisValue);
    
      // Set value on next select and trigger change
      const productFormInput = label.closest('.product-form__input');
      if (productFormInput) {
        const nextSelect = productFormInput.nextElementSibling;
        if (nextSelect && nextSelect.tagName === 'SELECT') {
          nextSelect.value = thisValue;
          nextSelect.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    
      // Get subscription variant id
      const subscriptionOption = document.querySelector('#custom_pl--subscription_values option[data-variant-main="' + thisValue + '"]');
    
      const thisValueid = subscriptionOption ? subscriptionOption.value : null;
      console.log('thisValueid::' + thisValueid);
    
      // Uncomment if needed
      // const subscriptionSelect = document.querySelector('#custom_pl--subscription_values');
      // if (subscriptionSelect && thisValueid) {
      //   subscriptionSelect.value = thisValueid;
      //   subscriptionSelect.dispatchEvent(new Event('change', { bubbles: true }));
      // }
    });
    document.addEventListener('change', function (e) {
      const radio = e.target.closest('variant-selects input[type="radio"]');
      if (!radio) return;
    
      let finalValue = '';
    
      // Collect all checked inputs
      document.querySelectorAll('variant-selects input:checked').forEach(function (input) {
          const selectVal = input.value;
          finalValue += selectVal + ' / ';
          console.log('selectVal::' + selectVal);
        });
    
      // Remove trailing " / "
      const newstr = finalValue.slice(0, -3);
      console.log('newstr::' + newstr);
    
      // Find matching subscription option
      const option = document.querySelector('#custom_pl--subscription_values option[data-sku-title="' + newstr +'"]');
    
      if (!option) return;
    
      const thisValueid = option.value;
    
      // Update select and trigger change
      const subscriptionSelect = document.querySelector('#custom_pl--subscription_values');
    
      if (subscriptionSelect) {
        subscriptionSelect.value = thisValueid;
        subscriptionSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
    document.addEventListener('change', function (e) {
      const selectEl = e.target.closest('#custom_pl--subscription_values');
      if (!selectEl) return;
    
      const thisvalId = selectEl.value;
    
      const selectedOption = selectEl.querySelector('option[value="' + thisvalId + '"]');
      if (!selectedOption) return;
    
      const regular_price = selectedOption.getAttribute('data-var-price');
      const subscription_price = selectedOption.getAttribute('data-price-sp');
    
      console.log('thisvalId::' + thisvalId);
      console.log('regular_price::' + regular_price);
      console.log('subscription_price::' + subscription_price);
    
      const checkLength = document.querySelectorAll('.recharge-subscription-widget .rc-widget .rc-template__button-group .rc-radio--active.subscription-radio').length;
    
      const productInfoWrapper = selectEl.closest('.product__info-wrapper');
      if (!productInfoWrapper) return;
    
      const regularPriceEl = productInfoWrapper.querySelector(
        '.pl--product_price .price-item--regular'
      );
      const priceWrapper = productInfoWrapper.querySelector('.pl--product_price');
      const subscriptionPriceText = productInfoWrapper.querySelector('.hawkstonine_price .hawkstonine_price_text');
    
      if (checkLength === 1) {
        if (regularPriceEl) regularPriceEl.textContent = regular_price;
        if (priceWrapper) priceWrapper.classList.add('pl-price-strike');
        if (subscriptionPriceText)
          subscriptionPriceText.textContent = subscription_price;
      } else {
        if (regularPriceEl) regularPriceEl.textContent = regular_price;
        if (priceWrapper) priceWrapper.classList.remove('pl-price-strike');
        if (subscriptionPriceText)
          subscriptionPriceText.textContent = subscription_price;
      }
    });
    document.addEventListener('click', function (e) {
      const option = e.target.closest(
        '.related-product-list .fbt_variants.related_product_variant ' +
        '.swatches-block .swatches-item-box .swatches-option'
      );
      if (!option) return;
    
      const optionName = option.getAttribute('data-value');
    
      // Remove "selected" from siblings
      const itemBox = option.closest('.swatches-item-box');
      if (itemBox) {
        itemBox.querySelectorAll('.swatches-option').forEach(function (el) {
          el.classList.remove('selected');
        });
      }
    
      // Add "selected" to clicked option
      option.classList.add('selected');
    
      // Update select value and trigger change
      const swatchesBlock = option.closest('.swatches-block');
      if (swatchesBlock) {
        const select = swatchesBlock.querySelector('select');
        if (select) {
          select.value = optionName;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    document.addEventListener('change', function (e) {
      const selectEl = e.target.closest('.related-product-list .fbt_variants.related_product_variant .swatches-block select');
      if (!selectEl) return;
    
      let finalValue = '';
    
      const parentVariant = selectEl.closest('.fbt_variants.related_product_variant');
      if (!parentVariant) return;
    
      const parentId = parentVariant.getAttribute('data-id');
    
      // Build combined option string
      parentVariant.querySelectorAll('.swatches-block').forEach(function (block) {
        const select = block.querySelector('select');
        if (select && select.value) {
          finalValue += select.value + ' / ';
        }
      });
    
      const skuString = finalValue.slice(0, -3); // remove trailing " / "
    
      // Find matching variant option
      const optionEl = parentVariant.querySelector('.product-form__master-select option[check-data-sku="' + skuString + '"]');
      if (!optionEl) return;
    
      const optionValue = optionEl.value;
      const selectedPrice = optionEl.getAttribute('data-price');
      const selectedAvailability = optionEl.getAttribute('data-varaint-availability');
      const selectedVariant = optionEl.value;
    
      // Update master select
      const masterSelect = parentVariant.querySelector('.product-form__master-select');
      if (masterSelect) {
        masterSelect.value = optionValue;
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    
      // Update price
      const relatedItem = selectEl.closest('.related_product_item');
      if (relatedItem) {
        const priceEl = relatedItem.querySelector('.related_product__price');
        if (priceEl) {
          priceEl.textContent = selectedPrice;
        }
      }
    
      // Update button state
      const productItem = selectEl.closest('.product_item');
      if (!productItem) return;
    
      const addBtn = productItem.querySelector('.btn_container .fbt_btn_add');
      const addBtnText = addBtn?.querySelector('span');
    
      if (!addBtn) return;
    
      addBtn.setAttribute('data-id', selectedVariant);
    
      if (selectedAvailability === 'true') {
        if (addBtnText) addBtnText.textContent = 'Add';
        if (addBtnText) addBtnText.setAttribute('data-id', selectedVariant);
        addBtn.classList.add('add');
        addBtn.classList.remove('soldout');
      } else {
        if (addBtnText) addBtnText.textContent = 'Soldout';
        addBtn.classList.add('soldout');
        addBtn.classList.remove('add');
      }
    });
    document.addEventListener('click', function (e) {
      const btn = e.target.closest( '.related-product-list .product_item .btn_container .fbt_btn_add');
      if (!btn) return;
    
      const variantId = btn.getAttribute('data-id');
      if (!variantId) return;
    
      const updateItems = [{
        id: variantId,
        quantity: 1
      }];
    
      ajaxAddToCartProduct(btn, updateItems);
    
      btn.classList.add('is-loading');
    
      const spinner = btn.querySelector('.loading-overlay__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
      }
    });
    
    // Bumper CODE cart product
    document.addEventListener('click', function (e) {
      const option = e.target.closest(
        '.cart_drawer_scroll .fbt_variants:not(.related_product_variant) .product-swatches.bumper_swatches .swatches-block .swatches-item-box .swatches-option');
      if (!option) return;
    
      const optionName = option.getAttribute('data-value');
    
      // Remove "selected" from siblings
      const itemBox = option.closest('.swatches-item-box');
      if (itemBox) {
        itemBox.querySelectorAll('.swatches-option').forEach(function (el) {
          el.classList.remove('selected');
        });
      }
    
      // Add "selected" to clicked option
      option.classList.add('selected');
    
      // Update select value and trigger change
      const swatchesBlock = option.closest('.swatches-block');
      if (swatchesBlock) {
        const select = swatchesBlock.querySelector('select');
        if (select) {
          select.value = optionName;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    document.addEventListener('change', function (e) {
      const selectEl = e.target.closest(
        '.cart_drawer_scroll .fbt_variants:not(.related_product_variant) .product-swatches.bumper_swatches .swatches-block select');
      if (!selectEl) return;
    
      let finalValue = '';
    
      const cartRelated = selectEl.closest('.cart_related_products');
      if (!cartRelated) return;
    
      cartRelated.querySelectorAll('.fbt_variants:not(.related_product_variant) .product-swatches.bumper_swatches .swatches-block select')
        .forEach(function (select) {
          const val = select.value;
          if (val) {
            finalValue += val + ' / ';
          }
        });
    
      if (!finalValue) return;
    
      const skuKey = finalValue.slice(0, -3);
    
      const productSwatches = selectEl.closest('.product-swatches');
      if (!productSwatches) return;
    
      const optionSelector = productSwatches.querySelector('.product-form__master-select option[check-data-sku="' + skuKey + '"]');
      if (!optionSelector) return;
    
      const optionValue = optionSelector.value;
      const selectedPrice = optionSelector.getAttribute('data-price');
      const selectedAvailability = optionSelector.getAttribute('data-varaint-availability');
      const selectedVariant = optionSelector.getAttribute('value');
    
      // Update master select
      const masterSelect = productSwatches.querySelector('.product-form__master-select');
      if (masterSelect) {
        masterSelect.value = optionValue;
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    
      const productItem = selectEl.closest('.product_item');
      if (!productItem) return;
    
      const addBtn = productItem.querySelector('.btn_container .fbt_btn_add');
      const btnText = addBtn ? addBtn.querySelector('span') : null;
    
      if (!addBtn || !btnText) return;
    
      addBtn.setAttribute('data-id', selectedVariant);
    
      if (selectedAvailability === 'true') {
        btnText.textContent = 'Add - ' + selectedPrice;
        btnText.setAttribute('data-id', selectedVariant);
        addBtn.removeAttribute('disabled');
      } else {
        btnText.textContent = 'Sold out';
        addBtn.setAttribute('disabled', '');
      }
    });
    document.addEventListener('click', function (e) {
      const btn = e.target.closest('.cart_drawer_scroll .cart_related_products .product_item .btn_container .fbt_btn_add');
      if (!btn) return;
    
      const variantId = btn.getAttribute('data-id');
      if (!variantId) return;
    
      const updateItems = [{
        id: variantId,
        quantity: 1
      }];
    
      ajaxAddToCartProduct(btn, updateItems);
    
      btn.classList.add('is-loading');
    
      const spinner = btn.querySelector('.loading-overlay__spinner');
      if (spinner) {
        spinner.classList.remove('hidden');
      }
    });
    
    // Bumper CODE Cart Product end
    document.addEventListener('click', function (e) {
      const option = e.target.closest('.cart_drawer_scroll .fbt_variants:not(.related_product_variant) .product-swatches:not(.bumper_swatches) .swatches-block .swatches-item-box .swatches-option');
      if (!option) return;
    
      const optionName = option.getAttribute('data-value');
    
      // Remove "selected" from siblings
      const itemBox = option.closest('.swatches-item-box');
      if (itemBox) {
        itemBox.querySelectorAll('.swatches-option').forEach(function (el) {
          el.classList.remove('selected');
        });
      }
    
      // Add "selected" to clicked swatch
      option.classList.add('selected');
    
      // Sync select + trigger change
      const swatchesBlock = option.closest('.swatches-block');
      if (swatchesBlock) {
        const select = swatchesBlock.querySelector('select');
        if (select) {
          select.value = optionName;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
    document.addEventListener('change', function (e) {
      const selectEl = e.target.closest('.cart_drawer_scroll .fbt_variants:not(.related_product_variant) .product-swatches:not(.bumper_swatches) .swatches-block select');
      if (!selectEl) return;
    
      let finalValue = '';
    
      const productItem = selectEl.closest('.product_item');
      if (!productItem) return;
    
      const parentId = productItem.getAttribute('fbt_product_id');
    
      document
        .querySelectorAll(
          '.product_item[fbt_product_id="' + parentId + '"] .fbt_variants:not(.related_product_variant) .product-swatches:not(.bumper_swatches) .swatches-block select')
        .forEach(function (select) {
          const val = select.value;
          if (val) {
            finalValue += val + ' / ';
          }
        });
    
      if (!finalValue) return;
    
      const skuKey = finalValue.slice(0, -3);
    
      const productSwatches = selectEl.closest('.product-swatches');
      if (!productSwatches) return;
    
      const optionEl = productSwatches.querySelector(
        '.product-form__master-select option[check-data-sku="' + skuKey + '"]'
      );
      if (!optionEl) return;
    
      const optionValue = optionEl.value;
      const selectedPrice = optionEl.getAttribute('data-price');
      const selectedAvailability = optionEl.getAttribute('data-varaint-availability');
      const selectedVariant = optionEl.getAttribute('value');
    
      // Update master select
      const masterSelect = productSwatches.querySelector('.product-form__master-select');
      if (masterSelect) {
        masterSelect.value = optionValue;
        masterSelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
    
      const addBtn = productItem.querySelector('.btn_container .fbt_btn_add');
      const btnText = addBtn ? addBtn.querySelector('span') : null;
    
      if (!addBtn || !btnText) return;
    
      addBtn.setAttribute('data-id', selectedVariant);
    
      if (selectedAvailability === 'true') {
        btnText.textContent = 'Add - ' + selectedPrice;
        btnText.setAttribute('data-id', selectedVariant);
      } else {
        btnText.textContent = 'Soldout';
      }
    });
    // document.addEventListener('click', function (e) {
    //   const closeBtn = e.target.closest('.fbt_product_main .closeBtn');
    //   if (!closeBtn) return;
    
    //   const productMain = closeBtn.closest('.fbt_product_main');
    //   if (!productMain) return;
    
    //   const parentId = productMain.getAttribute('product__id');
    
    //   document.querySelectorAll('.fbt_product_main[product__id="' + parentId + '"]').forEach(function (el) {
    //       el.style.display = 'none';
    //     });
    // });
    document.addEventListener('click', function (e) {
      const closeBtn = e.target.closest('.bumper_product .fbt_heading .closeBtn');
      if (!closeBtn) return;
    
      const bumperProduct = closeBtn.closest('.bumper_product');
      if (bumperProduct) {
        bumperProduct.style.display = 'none';
      }
    });
    document.addEventListener("click", function (e) {
      if (e.target.closest(".product__description #read_more_text")) {
        const container = document.querySelector(".product__description");
        if (!container) return;
        container.querySelector(".after-description")?.style.setProperty("display", "block");
        container.querySelector(".before-description")?.style.setProperty("display", "none");
        return;
      }
      if (e.target.closest(".product__description #read_less_text")) {
        const container = document.querySelector(".product__description");
        if (!container) return;
        container.querySelector(".after-description")?.style.setProperty("display", "none");
        container.querySelector(".before-description")?.style.setProperty("display", "block");
        return;
      }
    });
    // account page 
    document.addEventListener("click", function (e) {
      const li = e.target.closest(".customer-header-nav .header__links li");
      if (!li) return;
      const siblings = li.parentElement.children;
      Array.from(siblings).forEach(function (item) {
        item.classList.remove("active");
      });
      li.classList.add("active");
    });
    const orderViews = document.querySelectorAll(".customer-header-nav .order__view");
   
   orderViews.forEach(function (orderView) {
     orderView.addEventListener("click", function () {
       const accountOverview = document.querySelector(".account-overview");
       const customerAddresses = document.getElementById("data-customer-addresses");
       const customerOrder = document.querySelector(".customer-order");
       const mainOrderDetails = document.querySelector(".main-order-details");
       
      if (accountOverview) accountOverview.style.display = "none";
      if (customerAddresses) customerAddresses.style.display = "none";
      if (customerOrder) customerOrder.style.display = "block";
      if (mainOrderDetails) mainOrderDetails.style.display = "none";
    });
    });
    document.addEventListener("click", function (e) {

      /* 1. Toggle edit dots + background */
      const editDots = e.target.closest(".account__name__dots .edit-address-dots");
      if (editDots) {
        editDots.classList.toggle("active");

        const editBg = document.querySelector(".edit-bt-bg");
        if (editBg) {
          editBg.style.display =
            editBg.style.display === "block" ? "none" : "block";
        }
        return;
      }

      /* 2. Open address overlay (desktop) */
      if (e.target.closest(".edit__address, .add-new-address-bt")) {
        const overlay = document.querySelector(".address-overlay");
        if (overlay) overlay.style.display = "block";

        document.body.classList.add("mega-menu-over-flow");
        return;
      }

      /* 3. Open address overlay (mobile) */
      if (e.target.closest(".add-new-address-bt-mobile")) {
        const overlay = document.querySelector(".address-overlay");
        if (overlay) overlay.style.display = "block";

        document.body.classList.add("mega-menu-over-flow");

        const addBtn = document.querySelector(".add-new-address-bt");
        if (addBtn) addBtn.setAttribute("aria-expanded", "true");
        return;
      }

      /* 4. Close overlay (close button or background click) */
      if (e.target.closest(".close__address") || e.target.classList.contains("address-overlay")) {
        closeAddressOverlay();
        return;
      }

      /* 5. Cancel button */
      if (e.target.closest(".cancel__button")) {
        closeAddressOverlay();
        return;
      }
    });
    function closeAddressOverlay() {
      const overlay = document.querySelector(".address-overlay");
      if (overlay) overlay.style.display = "none";
      document.body.classList.remove("mega-menu-over-flow");
      document.querySelectorAll(".edit__address, .add-new-address-bt").forEach(el => el.setAttribute("aria-expanded", "false"));
    }
    // blog page video play/pause
    document.addEventListener('click', function (e) {
      const playBtn = e.target.closest('.cover-img-video .video-play');
      if (!playBtn) return;
    
      const coverWrapper = playBtn.closest('.cover-img-video');
      if (!coverWrapper) return;
    
      // Play current video
      const currentVideo = coverWrapper.querySelector('video');
      if (currentVideo) {
        currentVideo.play();
        currentVideo.muted = false;
      }
    
      // Hide current cover image
      const coverImage = coverWrapper.querySelector('.cover_image');
      if (coverImage) {
        coverImage.style.display = 'none';
      }
    
      // Pause sibling videos and show their cover images
      const videoContainer = playBtn.closest('.video');
      if (videoContainer) {
        const siblingVideos = videoContainer.parentElement
          ? videoContainer.parentElement.querySelectorAll('.video')
          : [];
    
        siblingVideos.forEach(function (videoEl) {
          if (videoEl === videoContainer) return;
    
          const siblingCover = videoEl.querySelector('.cover_image');
          const siblingVideo = videoEl.querySelector('video');
    
          if (siblingVideo) siblingVideo.pause();
          if (siblingCover) siblingCover.style.display = 'block';
        });
      }
    });
    document.addEventListener('click', function (e) {
      const pauseBtn = e.target.closest('.cover-img-video .video-pause');
      if (!pauseBtn) return;
    
      // Hide pause button
      pauseBtn.style.display = 'none';
    
      const coverWrapper = pauseBtn.closest('.cover-img-video');
      if (!coverWrapper) return;
    
      // Remove playing class
      coverWrapper.classList.remove('videoPlay');
    
      // Pause video
      const video = coverWrapper.querySelector('#background-video');
      if (video) {
        video.pause();
      }
    
      // Show play button
      const videoContainer = pauseBtn.closest('.video');
      if (videoContainer) {
        const playBtn = videoContainer.querySelector('.cover-img-video .video-play');
        if (playBtn) {
          playBtn.style.display = 'block';
        }
      }
    });
    // Blog load more function
    loadmoreByButton();

    function loadmoreByButton() {
      let nextUrl = document.querySelector('.pl--_more')?.getAttribute('link');

      // Load more button
      document.body.addEventListener('click', function (e) {
        const loadMoreBtn = e.target.closest('.pl--_more');
        if (!loadMoreBtn) return;

        e.preventDefault();
        if (!nextUrl) return;

        loadMoreBtn.textContent = 'Loading...';

        fetch(nextUrl)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');

            const newArticles = doc.querySelector('#article_load_more');
            const newLoadMoreBtn = doc.querySelector('#loadMoreBtn');

            if (newArticles) {
              document
                .querySelector('#article_load_more')
                .insertAdjacentHTML('beforeend', newArticles.innerHTML);
            }

            if (newLoadMoreBtn) {
              document.querySelector('#loadMoreBtn').innerHTML = newLoadMoreBtn.innerHTML;
            }

            nextUrl = doc.querySelector('.pl--_more')?.getAttribute('link') || null;
          });
      });

      // Tag category button
      document.body.addEventListener('click', function (e) {
        const tagBtn = e.target.closest('.tag-catg-button:not(.blog-catg-button)');
        if (!tagBtn) return;

        e.preventDefault();

        const tagUrl = tagBtn.getAttribute('href');
        const tagName = tagBtn.getAttribute('data-tag-name');

        tagBtn.textContent = 'Loading...';

        fetch(tagUrl)
          .then(response => response.text())
          .then(data => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(data, 'text/html');

            document.querySelectorAll('.blog-catg-list').forEach(el => {
              el.style.display = 'none';
            });

            document
              .querySelectorAll('.tag-catg-button[data-tag-name="' + tagName + '"]')
              .forEach(btn => {
                btn.textContent = tagName;
              });

            const tagContent = doc.querySelector('#pl--loadmore_tag');
            if (tagContent) {
              document.querySelector('#pl--loadmore_tag').innerHTML = tagContent.innerHTML;
            }
          });
      });
    }
// pl--footprint_block
  document.addEventListener('click', function (e) {
    const footprintBlock = e.target.closest('.pl--footprint_block');
    if (!footprintBlock) return;

    setTimeout(function () {
      const checkbox = footprintBlock.querySelector('#pl--footprint_item');
      const isChecked = checkbox && checkbox.checked;

      const payload = {
        attributes: {
          'Combined Order': isChecked ? 'True' : 'False'
        }
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      })
        .then(() => fetch('/'))
        .then(response => response.text())
        .then(html => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newBlock = doc.querySelector('.pl--footprint_block');
          if (newBlock) {
            document.querySelectorAll('.pl--footprint_block').forEach(el => {
              el.innerHTML = newBlock.innerHTML;
            });
          }
        })
        .catch(() => {
          // silent fail (matches original behavior)
        });
    }, 500);
  });
  document.addEventListener('click', function (e) {
    const selected = e.target.closest('.more-option-display .selected-option');
    if (!selected) return;
  
    document
      .querySelectorAll('.more-option-display ul')
      .forEach(function (ul) {
        if (ul !== selected.nextElementSibling) {
          ul.style.display = 'none';
        }
      });
  
    const nextUl = selected.nextElementSibling;
    if (nextUl && nextUl.tagName === 'UL') {
      nextUl.style.display = nextUl.style.display === 'none' ? 'block' : 'none';
    }
  });
  // Option click
  document.addEventListener('click', function (e) {
  const option = e.target.closest('.more-option-display ul li');
  if (!option) return;

  const thisValue = option.getAttribute('value');

  const moreOption = option.closest('.more-option-display');
  if (!moreOption) return;

  // previous select
  const preSelect = moreOption.previousElementSibling;

  // previous .product-form__input
  const mainPreElement = preSelect?.previousElementSibling;
  if (mainPreElement) {
    mainPreElement.classList.add('testt');

    const inputLabel = mainPreElement.querySelector(
      'input[value="' + thisValue + '"] + label'
    );
    if (inputLabel) {
      inputLabel.click();
    }
  }

  // Update selected value text
  const selectedValue = moreOption.querySelector('.selected-option .selected-value');
  if (selectedValue) {
    selectedValue.textContent = thisValue;
  }

  // Hide dropdown
  moreOption.querySelectorAll('ul').forEach(ul => {
    ul.style.display = 'none';
  });
  });


  // Close dropdown when clicking outside
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.more-option-display')) {
      document
        .querySelectorAll('.more-option-display ul')
        .forEach(function (ul) {
          ul.style.display = 'none';
        });
    }
  });
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.pl-sound-button');
    if (!btn) return;
  
    const video = document.querySelector('.banner-autoplay-video.cover-video video');
    if (!video) return;
  
    const soundState = btn.getAttribute('sound');
  
    if (soundState === 'true') {
      // Unmute
      btn.setAttribute('sound', 'false');
      video.muted = false;
      btn.textContent = 'Mute';
  
      document.querySelectorAll('.pl-sound-button .sound').forEach(el => {
        el.style.display = 'none';
      });
      document.querySelectorAll('.pl-sound-button .mute').forEach(el => {
        el.style.display = 'block';
      });
    } else if (soundState === 'false') {
      // Mute
      btn.setAttribute('sound', 'true');
      video.muted = true;
      btn.textContent = 'Sound';
  
      document.querySelectorAll('.pl-sound-button .sound').forEach(el => {
        el.style.display = 'block';
      });
      document.querySelectorAll('.pl-sound-button .mute').forEach(el => {
        el.style.display = 'none';
      });
    }
  });
  document.addEventListener('click', function (e) {
    const openBtn = e.target.closest('.size_guide-text');
    if (openBtn) {
      const wrap = document.querySelector('.main_size-wrap');
      if (wrap) wrap.classList.add('active');
      document.body.classList.add('overflow-hidden');
      return;
    }
  
    const closeBtn = e.target.closest('.close__icon');
    if (closeBtn) {
      const wrap = document.querySelector('.main_size-wrap');
      if (wrap) wrap.classList.remove('active');
      document.body.classList.remove('overflow-hidden');
    }
  });
  

  // gift card

  document.addEventListener('click', function (e) {
  const option = e.target.closest('.cdk_gift_variant_option');
  if (!option) return;

  // Get image src
  const img = option.querySelector('img');
  const imageSrc = img ? img.getAttribute('src') : null;

  console.log(imageSrc);

  // Set input value
  const input = document.querySelector('#cdk_giftimage');
  if (input && imageSrc) {
    input.value = imageSrc;
  }

  // Handle active class
  const siblings = option.parentElement
    ? option.parentElement.querySelectorAll('.cdk_gift_variant_option')
    : [];

  siblings.forEach(el => el.classList.remove('active'));
  option.classList.add('active');
});

  const giftInputs = document.querySelectorAll('.gift_message input');
  const validateButton = document.querySelector('.pl--validation_gift');
  // Keyup validation
  giftInputs.forEach(input => {
    input.addEventListener('keyup', () => {
      validateFields();
    });
  });
  // Button click validation
  if (validateButton) {
    validateButton.addEventListener('click', (event) => {
      event.preventDefault();
      validateFields();
    });
  }
  function validateFields() {
    const giftMessages = document.querySelectorAll('.gift_message');
    // Reset state
    giftMessages.forEach(gift => {
      gift.classList.remove('error');
      const message = gift.querySelector('.validation-message');
      if (message) message.textContent = '';
    });

    if (validateButton) validateButton.style.display = 'block';

    let isValid = true;

    giftInputs.forEach(input => {
      const inputValue = input.value.trim();
      const parentDiv = input.closest('.gift_message');
      const validationMessage = parentDiv?.querySelector('.validation-message');

      if (inputValue === '') {
        isValid = false;
        parentDiv.classList.add('error');
        if (validationMessage) {
          validationMessage.textContent = 'This field is required';
        }
      }
    });
    if (isValid) {
      // Proceed with form submission or other actions
      if (validateButton) validateButton.style.display = 'none';
    }
  }

  // video with text 
  document.addEventListener("click", (e) => {
    const btn = e.target.closest(".video-with-text .play_btn");
    if (!btn) return;

    const media = btn.closest(".video-with-text__media");
    const video = media?.querySelector("video");
    if (!video) return;

    video.muted = false;
    video.play();
    media.classList.add("video_playing");
  });

  //Hawkstone-hervest-quesion-answer
  document.addEventListener("click", function (e) {
    const answer = e.target.closest(".answer");
    if (!answer) return;
    // Toggle selected class
    answer.classList.toggle("selected");
    // Check if any answer is selected
    const anySelected = document.querySelectorAll(".answer.selected").length > 0;
    const button = document.querySelector(
      ".hoawkstone-question-answer-wrapper-button a.button"
    );
    if (!button) return;
    if (anySelected) {
      button.removeAttribute("disabled");
      button.classList.remove("disabled-link");
    } else {
      button.setAttribute("disabled", "disabled");
      button.classList.add("disabled-link");
    }
  });

  // Prevent default action for disabled links
    document.addEventListener("click", function (e) {
    const disabledLink = e.target.closest(".disabled-link");
    if (!disabledLink) return;

    e.preventDefault();
  });

  // CART DRAWER TEXT SHOW
  document.addEventListener("click", function (e) {
  const button = e.target.closest('button[data-btn-disable]');
  if (!button) return;
  e.preventDefault();
    const textSub = document.querySelector('.pl--btn_text_sub');
    if (textSub) {
      textSub.style.display = 'block';
    }
  });
  document.addEventListener('click', function (e) {

    // Open menu
    if (e.target.closest('.header__icon .icon-hamburger')) {
      document.documentElement.classList.add('mobile-overflow-hidden');
      document.body.classList.add('menu-bottom-border');
      return;
    }

    // Close menu
    if (e.target.closest('.header__icon .icon-close')) {
      document.documentElement.classList.remove('mobile-overflow-hidden');
      document.body.classList.remove('menu-bottom-border');
    }

  });
  document.addEventListener('click', function(e){
    if (e.target.closest('.video-section .deferred-media__poster-button')) {
      document.querySelectorAll('.video-section .video_button').forEach(btn => btn.style.display = 'none');
      document.querySelectorAll('.video-section').forEach(sec => sec.classList.add('section-image-opacity'));
    }
  });
  document.querySelectorAll('.custom__country .link').forEach(option => {
    option.addEventListener('click', function () {
      const countryCode = this.dataset.value;
      if (countryCode === 'IE') {
        window.location.href = '//hawkstone-ireland.myshopify.com';
        return;
      }
    });
  });
  

})